<template>
    <div>
        <b-container>
            <b-row>
                <b-col>
                    <h1>
                        Register
                    </h1>

                    <b-form @submit.prevent="onSubmit()">
                        <b-form-group>
                            <label>
                                Name
                            </label>

                            <b-form-input
                                v-model="form.name"
                                type="text"
                                required>
                            </b-form-input>
                        </b-form-group>

                        <b-form-group>
                            <label>
                                Email Address
                            </label>

                            <b-form-input
                                v-model="form.email"
                                type="email"
                                required>
                            </b-form-input>
                        </b-form-group>

                        <b-form-group>
                            <label>
                                Password
                            </label>

                            <b-form-input
                                v-model="form.password"
                                type="password"
                                required>
                            </b-form-input>
                        </b-form-group>

                        <b-form-group
                            :state="form.confirm_password.length > 0 && form.confirm_password == form.password"
                            :invalid-feedback="'Passwords must be the same.'">

                            <label>
                                Confirm Password
                            </label>

                            <b-form-input
                                v-model="form.confirm_password"
                                type="password"
                                required>
                            </b-form-input>
                        </b-form-group>

                        <b-button type="submit" variant="primary">
                            Register
                        </b-button>
                    </b-form>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                form: {
                    name: "",
                    email: "",
                    password: "",
                    confirm_password: ""
                }
            }
        },

        methods: {
            onSubmit() {

            }
        }
    }
</script>

<style scoped>

</style>